/**
 * Browser `fetch` must run with Window/WorkerGlobalScope as `this`.
 * Storing a bare `fetch` reference and calling it unbound throws:
 * "'fetch' called on an object that does not implement interface Window."
 */
export function resolveFetchImpl(custom?: typeof fetch): typeof fetch {
  if (custom) {
    return custom;
  }
  return (input: RequestInfo | URL, init?: RequestInit): Promise<Response> =>
    globalThis.fetch(input, init);
}
